import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import styles from "./BetShuffle.module.scss";
import ShuffleIcon from "../../assets/icons/shuffle_icon.svg";
import { sendAnalyticsEvent } from "../../lib/postMessage";
import ToolTip from "../OnboardingPopup/components/ToolTip";

const BetShuffle = ({ closeOnboarding }) => {
  const dispatch = useDispatch();
  const { ppConfig, onboardingStep } = useSelector((state) => state.filter);
  const isLoading = Object.keys(ppConfig).length === 0;

  const openBetShuffle = () => {
    dispatch({ type: "SET_ACTIVE_VIEW", payload: "betShuffle" });

    sendAnalyticsEvent({
      event: "Shuffle",
      type: "Shuffle",
      action: "Open",
    });
  };

  if (isLoading) return <div className={styles.spacer} />;

  return (
    <div
      className={`${styles.betShuffle} ${
        onboardingStep === 7 ? styles["betShuffle--highlighted"] : ""
      }`}
    >
      <div className={styles.betShuffleIcon}>
        <img src={ShuffleIcon} alt="Shuffle" />
      </div>
      <div className={styles.betShuffleMessage}>
        <div className={styles.betShuffleMessageHeading}>
          Already tried filtering?
        </div>
        <div>Grab a quick bet builder powered by top-notch stats!</div>
      </div>
      <div className={styles.betShuffleButton}>
        <button
          type="button"
          onClick={openBetShuffle}
          aria-label="bet-shuffle-button"
        >
          Bet Shuffle
        </button>
      </div>
      {/* If onboarding is active then we show the ToolTip relative to the Bet Shuffle */}
      {onboardingStep === 7 ? (
        <ToolTip closeOnboarding={closeOnboarding} />
      ) : null}
    </div>
  );
};

BetShuffle.propTypes = {
  closeOnboarding: PropTypes.func.isRequired,
};

export default BetShuffle;
